<template>
  <b-container>
    <b-toaster position="top-right" :no-auto-hide="false" :visible="true"></b-toaster>
    <b-card title="Send Email">
      <b-form @submit.prevent="sendEmail">
        <b-row>
          <b-col md="12">
            <b-form-group>
              <template #label>
                Subject <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.subject"
                placeholder="Subject"
                required
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <div class="d-flex justify-content-between align-items-center w-100">
                <div>Division</div>
                <b-form-checkbox
                  v-model="sendToAll"
                  switch
                  class="mb-0"
                  @change="onToggleSendToAll"
                  :disabled="disabledSendToAll"
                >
                  Send to All
                </b-form-checkbox>
              </div>
                <Select2
                  v-model="form.division"
                  :options="divisionOptions"
                  :settings="{
                    placeholder: 'choose...',
                    allowClear: true,
                    multiple: true,
                  }"
                  :disabled="disabledDivision"
                  @change="handleDivisionChange"
                />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <div>To <span class="text-danger">*</span></div>
              <Select2
                v-model="form.to"
                :settings="select2SettingsLabel"
                id="to"
                :disabled="disabledTo"
                required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Cc">
              <Select2
                v-model="form.cc"
                :settings="select2SettingsLabel"
                id="cc"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Bcc">
              <Select2
                v-model="form.bcc"
                :settings="select2SettingsLabel"
                id="bcc"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group>
              <template #label>
                Content <span class="text-danger">*</span>
              </template>
              <quill-editor
                v-model="form.content"
                :options="snowOption"
                id="content"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-for="(att, index) in attachments"
            :key="index"
            sm="12"
          >
            <b-form-group :label="`Attachment`">
              <b-form-file
                v-model="attachments[index].file"
                :state="Boolean(attachments[index].file)"
                placeholder="Choose a file..."
                accept=".jpg,.jpeg,.png,.gif,.pdf"
                @change="validateAttachmentSize($event, index)"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <b-button
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top="'Add Attachments'"
                @click="addAttachments"
              >
                <feather-icon icon="PlusIcon" />
                Add Attachments
              </b-button>

              <b-button
                variant="outline-danger"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top="'Remove Last Attachments'"
                @click="removeLastAttachments"
                :disabled="attachments.length === 1"
              >
                <feather-icon icon="TrashIcon" />
                Delete Attachments
              </b-button>
            </b-form-group>
          </b-col>
          <b-col sm="12" class="d-flex justify-content-end">
            <b-button type="button" class="mr-1" variant="light" @click="cancel">
              Back
            </b-button>
            <b-button type="submit" variant="primary" :disabled="isLoading">
              {{ isLoading ? 'Sending...' : 'Send Email' }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BButton,
  BFormCheckbox,
  VBTooltip,
} from 'bootstrap-vue'
import Quill from 'quill'
import Select2 from 'v-select2-component'
import { quillEditor } from 'vue-quill-editor'
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'

const Font = Quill.import("formats/font");
Font.whitelist = ["sans", "serif", "monospace"];
Quill.register(Font, true);

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BButton,
    Select2,
    BFormCheckbox,
    quillEditor,
  },
  data() {
    return {
      token: '',
      isLoading: false,
      sendToAll: false,
      disabledDivision: false,
      disabledTo: false,
      disabledSendToAll: false,
      attachments: [{ file: null }],
      form: {
        to: [],
        cc: [],
        bcc: [],
        subject: '',
        content: '',
        division: [],
      },
      select2SettingsLabel: {
        placeholder: 'choose...',
        allowClear: true,
        multiple: true,
        ajax: null,
      },
      divisionList: [],
      select2SettingsDivision: {
        placeholder: 'choose...',
        allowClear: true,
        multiple: true,
        data: [],
      },
       snowOption: {
        theme: 'snow',
        modules: {
         toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: ['sans', 'serif', 'monospace'] }],
          [{ size: ['small', false, 'large', 'huge'] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          ['blockquote'],
        ]
      }
      },
      divisionOptions: [],
    }
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)

    this.select2SettingsLabel.ajax = {
      transport: (params, success, failure) => {
        const searchWord = (params.data.term || '').trim()
        const page = params.data.page || 1
        const perPage = 10
        const skip = (page - 1) * perPage
        const sortBy = 'EMAIL_ADDRESS'
        const sortDesc = true

        const url = `/user/with.total/true/take/${perPage}/skip/${skip}${
          searchWord ? `/s/${searchWord}` : ''
        }/orderBy.${sortBy}/${sortDesc ? 'desc' : 'asc'}`

        this.$http
          .get(url, {
            headers: { 'Client-Device': 'browser' },
          })
          .then((res) => {
            success(res.data.data)
          })
          .catch((err) => {
            failure(err)
          })
      },
      processResults: (data, params) => {
        const records = data?.records || []
        return {
          results: records.map((item) => ({
            id: item.EMAIL_ADDRESS,
            text: `${item.NAME} - ${item.EMAIL_ADDRESS}`,
          })),
          pagination: {
            more: records.length === 10,
          },
        }
      },
      cache: true,
    }

    this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/notificationCenter/division`, {
      headers: {
        'Client-Device': 'browser',
        Authorization: `Bearer ${this.token}`,
      },
    }).then((res) => {
      const divisions = res.data.data || []
      this.divisionOptions = divisions.map((item) => ({
        id: item.DIVISION,
        text: item.DIVISION,
      }))
    })
  },

  mounted() {
    $(this.$refs.summernote).summernote({
      placeholder: 'Type your message...',
      tabsize: 2,
      height: 200,
      callbacks: {
        onChange: (contents) => {
          this.form.content = contents
        }
      }
    });

    $(this.$refs.summernote).summernote('code', this.form.content);
  },  
  methods: {
    cancel() {
      this.$router.back()
    },
      onToggleSendToAll() {
        if (this.sendToAll) {
          this.form.to = []
          this.form.division = []
          this.disabledDivision = true
          this.disabledTo = true
        } else {
          this.disabledDivision = false
          this.disabledTo = false
        }
      },
    addAttachments() {
      this.attachments.push({ file: null })
    },
    removeLastAttachments() {
      if (this.attachments.length > 1) {
        this.attachments.pop()
      }
    },
    quillToEmailHTML(html) {
      const wrapStart =
        '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center"><table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="left">';
      const wrapEnd = '</td></tr></table></td></tr></table>';

      const parser = new DOMParser();
      const doc = parser.parseFromString(html || '', 'text/html');

      const applyEmailStyles = (el) => {
        if (!el || !el.getAttribute) return;
        const cls = el.classList || [];
        let fontFamily = "Arial, Helvetica, sans-serif";
        let fontSize = "14px";
        let align = "left";
        let color = "";
        let bgColor = "";
        if (cls.contains("ql-font-serif")) {
          fontFamily = "Georgia, Times, 'Times New Roman', serif";
        } else if (cls.contains("ql-font-monospace")) {
          fontFamily = "'Courier New', Courier, monospace";
        }
        if (cls.contains("ql-size-small")) fontSize = "12px";
        else if (cls.contains("ql-size-large")) fontSize = "18px";
        else if (cls.contains("ql-size-huge")) fontSize = "24px";
        if (cls.contains("ql-align-center")) align = "center";
        else if (cls.contains("ql-align-right")) align = "right";
        else if (cls.contains("ql-align-justify")) align = "justify";
        cls.forEach((c) => {
          if (c.startsWith("ql-color-")) {
            color = c.replace("ql-color-", "");
          }
          if (c.startsWith("ql-bg-")) {
            bgColor = c.replace("ql-bg-", "");
          }
        });

        if (el.style.color) color = el.style.color;
        if (el.style.backgroundColor) bgColor = el.style.backgroundColor;
        let style = `font-family:${fontFamily}; font-size:${fontSize}; line-height:1.5;`;
        if (color) style += ` color:${color};`;
        if (bgColor) style += ` background-color:${bgColor};`;

        el.setAttribute("style", style);
        el.setAttribute("align", align);
        el.removeAttribute("class");
      };
      const targets = doc.querySelectorAll("p, div, li, td, th, span");
      targets.forEach(applyEmailStyles);
      doc.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach((h) => {
        const sizes = {
          H1: "32px",
          H2: "28px",
          H3: "24px",
          H4: "20px",
          H5: "18px",
          H6: "16px",
        };
        h.setAttribute(
          "style",
          `margin:16px 0; font-weight:bold; font-family:Arial, Helvetica, sans-serif; font-size:${sizes[h.tagName]}; line-height:1.4;`
        );
      });
      doc.querySelectorAll("ul,ol").forEach((list) => {
        list.setAttribute(
          "style",
          "margin:0 0 16px 24px; padding:0; list-style-position:inside; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:1.5;"
        );
      });
      doc.querySelectorAll("blockquote").forEach((bq) => {
        bq.setAttribute(
          "style",
          "margin:16px 0; padding:10px 20px; border-left:4px solid #cccccc; font-style:italic; font-family:Georgia, Times, 'Times New Roman', serif; font-size:14px; color:#555555; background:#f9f9f9;"
        );
      });
      doc.querySelectorAll("img").forEach((img) => {
        img.setAttribute("border", "0");
        img.setAttribute("style", "max-width:100%; height:auto; display:block;");
      });

      return wrapStart + doc.body.innerHTML + wrapEnd;
    },
    async sendEmail() {
      this.isLoading = true
      for (let i = 0; i < this.attachments.length; i++) {
        const att = this.attachments[i]
        if (att.file && att.file.size > 5 * 1024 * 1024) {
          this.$bvToast.toast(`File is over 5MB. Please select a smaller attachment.`, {
            variant: 'danger',
            solid: true,
          })
          this.isLoading = false
          return
        }
      }
      const emailSafeHTML = this.quillToEmailHTML(this.form.content)
      const formData = new FormData()
      formData.append('subject', this.form.subject)
      formData.append('sendToAll', JSON.stringify(this.sendToAll))
      if (this.form.division.length > 0) {
        formData.append('sendByDivision', JSON.stringify(this.form.division))
      }
      formData.append('to', JSON.stringify(this.form.to))
      formData.append('cc', JSON.stringify(this.form.cc))
      formData.append('bcc', JSON.stringify(this.form.bcc))
      formData.append('content', emailSafeHTML)

      this.attachments.forEach((att, index) => {
        if (att.file) formData.append(`file_${index + 1}`, att.file)
      })

      try {
        await this.$http.post(
          `${process.env.VUE_APP_API_HELPER_URL}/notificationCenter/featuresBlast`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: this.token,
            },
          }
        )

        this.$bvToast.toast('Your email has been sent.', {
          title: '✅ Success',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
          autoHideDelay: 5000,
        })

        setTimeout(() => {
          this.$router.push({ name: 'admin-notification-center' })
        }, 2000)
      } catch (error) {
        this.$bvToast.toast('Please try again later.', {
          title: '❌ Error',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right',
          autoHideDelay: 5000,
        })
      } finally {
        this.isLoading = false
      }
    },
  handleDivisionChange() {
      if (this.form.division.length > 0) {
        this.form.to = []
        this.disabledTo = true
        this.sendToAll = false
        this.disabledSendToAll = true
      } else {
        this.disabledTo = false
        this.disabledSendToAll = false
      }
    },

    validateAttachmentSize(event, index) {
      const file = event.target.files[0]
      const maxSize = 5 * 1024 * 1024
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf']
      if (file) {
        if (!allowedTypes.includes(file.type)) {
          this.$bvToast.toast(`File type not allowed. Only JPG, PNG, GIF, or PDF are accepted.`, {
            variant: 'danger',
            solid: true,
          })
          this.attachments[index].file = null
          event.target.value = null
          return
        }
        if (file.size > maxSize) {
          this.$bvToast.toast(`File is over 5MB. Please select a smaller attachment.`, {
            variant: 'danger',
            solid: true,
          })
          this.attachments[index].file = null
          event.target.value = null
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import '~quill/dist/quill.snow.css'; 
.ql-toolbar {
  overflow: visible !important;
  position: relative !important;
  z-index: 10 !important;
}

.ql-toolbar .ql-picker-options {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  z-index: 9999 !important;
  background: white;
  border: 1px solid #ccc;
}
.ql-font-sans {
  font-family: Arial, Helvetica, sans-serif !important;
}
.ql-font-serif {
  font-family: Georgia, "Times New Roman", Times, serif !important;
}
.ql-font-monospace {
  font-family: "Courier New", Courier, monospace !important;
}

</style>

<style scoped>

</style>
